export const getMeasurementElement = (element: string | JSX.Element): { width: number; height: number } => {
  const container = document.createElement('p')
  container.style.fontSize = '14px'
  container.style.lineHeight = '22px'
  container.style.width = 'max-content'
  container.style.padding = '12px'

  if (typeof element === 'string') {
    container.innerHTML = element
  } else {
    const componentText = element.props.children?.replaceAll('\n', '<br />')
    container.innerHTML = componentText
  }

  document.body.appendChild(container)

  const height = container.clientHeight
  const width = container.clientWidth

  if (container.parentNode) container.parentNode.removeChild(container)
  return { height, width }
}
